import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'newPhoneModalSlice';

export const newPhoneSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleNewPhoneModal(state) {
            state.isOpen = !state.isOpen;
        },
    },
});

export const { toggleNewPhoneModal } = newPhoneSlice.actions;

export const newPhoneModalStateSelector = state => state.newPhoneModal.isOpen;

export const newPhoneModal = newPhoneSlice.reducer;
